module.exports = __webpack_public_path__ + "img/11.d16bd909.jpg";